import { useLocation } from "react-router";

export function useBackLink() {
	const location = useLocation();

	return (location.state as { back_link?: string } | undefined)?.back_link as
		| string
		| undefined;
}
